import { Board } from 'modules/core/domain/interfaces/supabase/overlay/entity';
import { MatchEventType } from 'shared/types/match-event';

/**
 * Табло, которые оверлей проигрывает для события, в порядке показа.
 *
 * На одно событие может быть подписано несколько табло — они играют подряд, это
 * штатное поведение. Но табло без объектов рисовать нечего, а очередь событий оно
 * всё равно держит свои `duration` секунд: в эфире это выглядит как пауза между
 * событиями, причём не связанная с длительностью того табло, которое реально видно.
 * Поэтому пустые табло сюда не попадают.
 */
export default function getBoardsForEvent(boards: Board[], eventType: MatchEventType): Board[] {
  return boards.filter((board) => board.type === 'events' && board.events.includes(eventType) && hasObjects(board));
}

function hasObjects(board: Board): boolean {
  return (board.objects?.length ?? 0) > 0;
}
